import Vue from "vue";
import dayjs from "@/helpers/dayjs";
import "dayjs/locale/ko";

Vue.filter("utcToLocal", (utc, format) => {
  return dayjs(utc).format(format);
});

Vue.filter("utcGetDay", (utc) => {
  dayjs.locale("ko");
  return dayjs(utc).format("ddd");
});

Vue.filter("phoneFormat", (number) => {
  return number.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
});
